import React from "react";

import DayPickerInput from "react-day-picker/DayPickerInput";
import { DateUtils } from "react-day-picker";

import "react-day-picker/lib/style.css";

import { formatDate, parseDate } from "react-day-picker/moment";

import "./DateRangeSelection.scss";

export default class DateRangeSelection extends React.Component {
  constructor(props) {
    super(props);
    this.handleFromChange = this.handleFromChange.bind(this);
    this.handleToChange = this.handleToChange.bind(this);
    this.getMinDate = this.getMinDate.bind(this);
    this.getMaxDate = this.getMaxDate.bind(this);
    this.getFromAfterDate = this.getFromAfterDate.bind(this);
    this.getToBeforeDate = this.getToBeforeDate.bind(this);
  }

  handleFromChange(from) {
    // Change the from date and focus the "to" input field
    this.props.fromUpdate(from);
  }

  handleToChange(to) {
    this.props.toUpdate(to);
  }

  getMinDate() {
    if (this.props.selectionRange) {
      const minDate = new Date(this.props.selectionRange.minDate);
      return minDate;
    } else {
      return null;
    }
  }

  getMaxDate() {
    if (this.props.selectionRange) {
      const maxDate = new Date(this.props.selectionRange.maxDate);
      return maxDate;
    } else {
      return null;
    }
  }

  getFromAfterDate() {
    // if to date is after max date limit selection till max date
    if (this.props.to && this.props.selectionRange) {
      const maxDate = new Date(this.props.selectionRange.maxDate);
      if (
        DateUtils.isSameDay(this.props.to, maxDate) ||
        DateUtils.isDayAfter(this.props.to, maxDate)
      ) {
        return new Date(maxDate.getDate() + 1);
      } else {
        return this.props.to;
      }
    } else {
      return this.props.to;
    }
  }

  getToBeforeDate() {
    // if from date is before min date limit selection till min date
    if (this.props.from && this.props.selectionRange) {
      const minDate = new Date(this.props.selectionRange.minDate);
      if (
        DateUtils.isSameDay(this.props.from, minDate) ||
        DateUtils.isDayBefore(this.props.from, minDate)
      ) {
        return new Date(minDate.getDate() - 1);
      } else {
        return this.props.from;
      }
    } else {
      return this.props.from;
    }
  }

  render() {
    const { from, to } = this.props;
    const modifiers = { start: from, end: to };
    return (
      <div className={`day-range-picker ${this.props.className ? this.props.className : ""}`}>
        <DayPickerInput
          value={from}
          inputProps={{ className: "form-control" }}
          placeholder="From"
          format="LL"
          formatDate={formatDate}
          parseDate={parseDate}
          dayPickerProps={{
            selectedDays: [from, { from, to }],
            disabledDays: {
              after: this.getFromAfterDate(),
              before: this.getMinDate(),
            },
            toMonth: to,
            modifiers,
            numberOfMonths: 2,
            onDayClick: () => this.to.getInput().focus(),
          }}
          onDayChange={this.handleFromChange}
        />{" "}
        —{" "}
        <span className="InputFromTo-to">
          <DayPickerInput
            ref={(el) => (this.to = el)}
            value={to}
            inputProps={{ className: "form-control" }}
            placeholder="To"
            format="LL"
            formatDate={formatDate}
            parseDate={parseDate}
            dayPickerProps={{
              selectedDays: [from, { from, to }],
              disabledDays: {
                before: this.getToBeforeDate(),
                after: this.getMaxDate(),
              },
              modifiers,
              month: from,
              fromMonth: from,
              numberOfMonths: 2,
            }}
            onDayChange={this.handleToChange}
          />
        </span>
      </div>
    );
  }
}
